import { configureStore } from '@reduxjs/toolkit'
import authSessionReducer from './auth'
import profileSessionReducer from './profile'
import delistingSessionReducer from './delisting'
export const store = configureStore({
  reducer: {
    authSession: authSessionReducer,
    profileSession: profileSessionReducer,
    delistingSession: delistingSessionReducer,
  },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
